"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.billingVoucherSum = exports.CreateBillingVoucherSchema = void 0;
const joi_1 = __importDefault(require("joi"));
const __1 = require("../..");
const performed_by_1 = require("../../performed-by");
exports.CreateBillingVoucherSchema = joi_1.default.object({
    currency: joi_1.default.string()
        .valid(...Object.values(__1.Currency))
        .required(),
    amount: joi_1.default.number().required(),
    date: joi_1.default.string().required(),
    voucherTypeId: joi_1.default.string().required(),
    caseId: joi_1.default.string().uuid().required(),
    billingVoucherId: joi_1.default.string().uuid().allow(null),
    createdAt: joi_1.default.string().allow(null),
    details: joi_1.default.any(),
    text: joi_1.default.string().allow(null),
    referenceId: joi_1.default.string().allow(null),
    createdBy: performed_by_1.PerformedBySchema.allow(null),
}).id('CreateCaseVoucherSchema');
const billingVoucherSum = (billingVouchers) => billingVouchers.reduce((acc, billingVoucher) => billingVoucher.amount + acc, 0);
exports.billingVoucherSum = billingVoucherSum;
//# sourceMappingURL=index.js.map